module.exports = __webpack_public_path__ + "./img/saved-collections-empty.svg";